export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7243.d03fc650.jpg";